import { apiURL, responseFormat } from '@/service/base'
import { MemberLoginReq } from '@circusmonkey/spock-protobuf/ts/account/account_pb'
import { MembersClient } from '@circusmonkey/spock-protobuf/ts/frontend/member_grpc_web_pb.js'

const client = new MembersClient(apiURL, null, null)

/**
 * 檢查Token
 * @param func
 * @returns {Promise<unknown>}
 */
async function checkToken(params = {}, func = null) {
	const req = new MemberLoginReq()
	req.setToken(params)

	const option = { 'grpc-session': null }
	const url = String(client.checkToken.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	let result = null
	return new Promise((resolve, reject) => {
		client.checkToken(req, option, (err, response) => {
			result = responseFormat(err, response, track)
		}).on('metadata', (metadata) => {
			// grpc-session取得後回塞
			if (metadata['grpc-session'] !== undefined && metadata['grpc-session'] !== '') {
				localStorage.setItem('grpc-session', metadata['grpc-session'])
				console.log('checkToken grpc-session', metadata['grpc-session'])
			}
			resolve(result) // 確定localStorage.setItem('grpc-session')
		})
	}).then(resp => resp)
}

export {
	checkToken
}
